/** LaunchDarkly-style DB feature flag key for the Manager Operating System. */
export const MANAGER_OPERATING_SYSTEM_FEATURE_FLAG = 'manager-operating-system';

/**
 * Hides the Members Progressed outcome until product QA enables the row.
 */
export const MANAGER_OPERATING_SYSTEM_MEMBERS_PROGRESSED_FEATURE_FLAG =
  'manager-operating-system-members-progressed';

/** Root path for the Manager Operating System application shell. */
export const MANAGER_OPERATING_SYSTEM_PREFIX_PATH = '/manager-operating-system';

/** Your Guides MOS landing path. */
export const MANAGER_OPERATING_SYSTEM_YOUR_GUIDES_PATH = `${MANAGER_OPERATING_SYSTEM_PREFIX_PATH}/your-guides`;

/** Team Workflow MOS path. */
export const MANAGER_OPERATING_SYSTEM_TEAM_WORKFLOW_PATH = `${MANAGER_OPERATING_SYSTEM_PREFIX_PATH}/team-workflow`;

/** Team Details MOS path. */
export const MANAGER_OPERATING_SYSTEM_TEAM_DETAILS_PATH = `${MANAGER_OPERATING_SYSTEM_PREFIX_PATH}/team-details`;

/** Detailed outcome workflow path prefix. The outcome id is the next segment. */
export const MANAGER_OPERATING_SYSTEM_OUTCOME_PATH_PREFIX = `${MANAGER_OPERATING_SYSTEM_PREFIX_PATH}/outcomes`;

/** Query key for the guide selected on Team Details. */
export const GUIDE_SEARCH_PARAM = 'guide';

/** Single guide MOS detail path prefix. */
export const MANAGER_OPERATING_SYSTEM_GUIDE_PATH_PREFIX = `${MANAGER_OPERATING_SYSTEM_PREFIX_PATH}/guide`;
